import { defineRecipe } from "@chakra-ui/react";

// Mirrors the input recipe, so a prose field sits next to a single-line
// one without looking like it came from somewhere else.
export default defineRecipe({
  variants: {
    variant: {
      outline: {
        background: "bg",
        borderWidth: "0",
        boxShadow: "input",

        _focusVisible: {
          boxShadow: "focusRing",
          outline: "none",
        },
      },
    },

    size: {
      md: {
        borderRadius: "l2",
        paddingY: "2",
      },
    },
  },
});
